import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { CustomFormBuilder } from '../../../../../../../libs/utils/ng-shared-components/src/lib/validation/form-builder/custom-form-builder';
import { CompanyDto, CompanyDtoFormGroup } from '../../../../../../../libs/utils/ts-shared/src/lib/api/dtos/CompanyDto';
import { PersonType } from '../../../../../../../libs/utils/ts-shared/src/lib/api/enums/PersonType';
import { LoginService } from '../../../../../../../libs/utils/auth-shared/src/lib/services/login.service';
import { Roles } from '../../../../api/enums/Roles';
import { AddressComponent } from '../../../../../../../libs/utils/ng-shared-components/src/lib/address/address.component';
import { IdDocumentComponent } from '../../../../../../../libs/utils/ng-shared-components/src/lib/id-document/id-document.component';

@Component({
  standalone: false,
  selector: 'mf-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss'],
})
export class CompanyComponent {
  constructor(private _cfb: CustomFormBuilder, private _loginService: LoginService) {}

  @Input()
  companyDto: CompanyDto;
  @ViewChild('address', { static: false }) address: AddressComponent;
  @ViewChild('idDocument', { static: false }) idDocument: IdDocumentComponent;
  @Output()
  save = new EventEmitter<CompanyDto>();

  personType = PersonType;
  isSuperAdmin = this._loginService.userIsInRole([Roles[Roles.SuperAdmin]]);

  companyForm = this._cfb.group<CompanyDtoFormGroup>({
    name: ['', Validators.required, 'Razón social'],
    commercialName: ['', Validators.required, 'Nombre fantasía'],
    idDocument: [null, null, 'Documento de identidad'],
    email: ['', [Validators.required, Validators.email], 'Email'],
    address: [null, null, 'Dirección'],
    isExemptFromOriginDeclaration: [false, Validators.required, 'No declara cuenta de origen'],
  });

  ngOnInit(): void {
    this.companyForm.patchValue(this.companyDto);
  }

  ngAfterViewInit(): void {
    const addressControl = this.companyForm.get('address')!;
    addressControl.setValidators(CustomFormBuilder.NestedFormValidator(this.address));
    addressControl.updateValueAndValidity();
    const idDocumentControl = this.companyForm.get('idDocument')!;
    idDocumentControl.setValidators(CustomFormBuilder.NestedFormValidator(this.idDocument));
    idDocumentControl.updateValueAndValidity();
  }

  @Output()
  close = new EventEmitter();
}
